import { SonCta } from '../components/cta'
import { Reveal } from '../components/hareket'
import { SssAkordeon } from '../components/sss-akordeon'
import { Baslik, SayfaUstu, Section } from '../components/ui'
import { MODULLER } from '../icerik/moduller'
import { GENEL_SSS } from '../icerik/sss'
import { useHead } from '../lib/head'

export function Sss() {
  useHead(
    {
      title: 'Sık sorulan sorular',
      description: 'Kurulum, deneme, veri taşıma, ödeme, güvenlik ve destek hakkında sorular.',
    },
    '/sss',
  )
  return (
    <>
      <SayfaUstu>
        <Section className="pt-0 sm:pt-0" dar>
          <Reveal>
            <Baslik
              seviye="h1"
              eyebrow="Sık sorulan sorular"
              baslik="Karar vermeden önce"
              metin="Cevabı burada olmayan bir soru için yazın; iş günlerinde aynı gün dönüyoruz."
            />
          </Reveal>
          <Reveal delay={0.1} className="mt-10">
            <SssAkordeon sorular={GENEL_SSS} />
          </Reveal>
          {MODULLER.map((m) => (
            <Reveal key={m.slug} className="mt-12">
              <h2 className="heading mb-4 text-xl text-ink">{m.ad}</h2>
              <SssAkordeon sorular={m.sss} />
            </Reveal>
          ))}
        </Section>
      </SayfaUstu>
      <SonCta />
    </>
  )
}
